export default () => {
	const {hostname} = window.location;
	const master = [
		'ac.bhp.lifeon.cl'
	];
	return !master.find(m => hostname.includes(m));
}
